/** Exact lift source identities checked against Ski Portillo's complete
 * fourteen-lift inventory on 8 September 2026. Durable ways survive geometry
 * changes; content hashes are compatibility aliases for the frozen archive.
 * https://skiportillo.com/en/our-mountain/portillo-snow-forecast-conditions/
 */
export const PORTILLO_LIFT_IDENTITIES = [
  {"osmId": "way/26598587", "contentId": "0aca0f1c36fbd5b04a1ba00eeadbf609d574b434", "name": "El Puma"},
  {"osmId": "way/258950664", "contentId": "26d55fd50014082fe90c2d277d9ba68ae8fe11f8", "name": "Condor"},
  {"osmId": "way/26597866", "contentId": "426bfb0b9504d03827b93c77dbe2a63bcaeb1840", "name": "Juncalillo"},
  {"osmId": "way/258949137", "contentId": "4b0a5aa4e99ca9cb22af448441383a65646459ca", "name": "El Corralito"},
  {"osmId": "way/258950816", "contentId": "5b82cf16b550590d4c5846b9da50399342905240", "name": "Roca Jack"},
  {"osmId": "way/258949136", "contentId": "61c10ee3c2e004ee3c73f0370fc3b6620386ae4b", "name": "Los Canarios"},
  {"osmId": "way/258948041", "contentId": "72631c083e3df6fa6e12bb00ec54d9327e284d7a", "name": "Cumbre"},
  {"osmId": "way/258950817", "contentId": "7f67a68a7ea2cc2e7fcdfa2bd223cf9b3fec8a16", "name": "Cara Cara"},
  {"osmId": "way/26597870", "contentId": "a924f5016cdfde5fb04b205d40cf3ff48127f977", "name": "Princesa"},
  {"osmId": "way/26489560", "contentId": "cbfd497ffaa4755e8b40979e04940517f5632ba7", "name": "Las Lomas"},
  {"osmId": "way/258950265", "contentId": "e8c0b63a9cdf8abebac676bc20ba2c0733b716b0", "name": "Conejo"},
  {"osmId": "way/26489558", "contentId": "eea8f42a207e37642548142c9387762fdcfad313", "name": "Plateau"},
  {"osmId": "way/258950665", "contentId": "f7fba69c83fb498d0e5dabccdf17dc64ea4dedda", "name": "Las Vizcachas"},
  {"osmId": "way/258950266", "contentId": "febf8a3d9c998f8e188d6af93d238686f9e23c7e", "name": "La Laguna"},
 ] as const;
const BY_SOURCE_ID = new Map<string, (typeof PORTILLO_LIFT_IDENTITIES)[number]>();
for (const lift of PORTILLO_LIFT_IDENTITIES) {
  BY_SOURCE_ID.set(lift.osmId, lift);
  BY_SOURCE_ID.set(lift.contentId, lift);
}
export function portilloLiftIdentity(sourceId: string | null | undefined) {
  return sourceId ? BY_SOURCE_ID.get(sourceId) : undefined;
}
